const initialState = () => {
  return {
    referenceNumber: null,
    errors: {
      applicationError: {
        hasError: null,
        error: []
      },
      createMarinaFormError: {
        hasError: null,
        error: []
      },
      maintenanceError: {
        hasError: null,
        error: []
      }
    }
  };
};

export default initialState;
